/** Every international dialing code (ITU/libphonenumber), numerically ordered.
 *  `countries` powers search, so a member can type "Israel" and land on +972. */
export const PHONE_CODES = [
  { code: "+1", countries: ["American Samoa", "Anguilla", "Antigua and Barbuda", "Bahamas", "Barbados", "Bermuda", "Canada", "Cayman Islands", "Dominica", "Dominican Republic", "Grenada", "Guam", "Jamaica", "Montserrat", "Northern Mariana Islands", "Puerto Rico", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Sint Maarten (Dutch part)", "Trinidad and Tobago", "Turks and Caicos Islands", "United States", "Virgin Islands, British", "Virgin Islands, U.S."] },
  { code: "+7", countries: ["Kazakhstan", "Russian Federation"] },
  { code: "+20", countries: ["Egypt"] },
  { code: "+27", countries: ["South Africa"] },
  { code: "+30", countries: ["Greece"] },
  { code: "+31", countries: ["Netherlands"] },
  { code: "+32", countries: ["Belgium"] },
  { code: "+33", countries: ["France"] },
  { code: "+34", countries: ["Spain"] },
  { code: "+36", countries: ["Hungary"] },
  { code: "+39", countries: ["Holy See (Vatican City State)", "Italy"] },
  { code: "+40", countries: ["Romania"] },
  { code: "+41", countries: ["Switzerland"] },
  { code: "+43", countries: ["Austria"] },
  { code: "+44", countries: ["Guernsey", "Isle of Man", "Jersey", "United Kingdom"] },
  { code: "+45", countries: ["Denmark"] },
  { code: "+46", countries: ["Sweden"] },
  { code: "+47", countries: ["Norway", "Svalbard and Jan Mayen"] },
  { code: "+48", countries: ["Poland"] },
  { code: "+49", countries: ["Germany"] },
  { code: "+51", countries: ["Peru"] },
  { code: "+52", countries: ["Mexico"] },
  { code: "+53", countries: ["Cuba"] },
  { code: "+54", countries: ["Argentina"] },
  { code: "+55", countries: ["Brazil"] },
  { code: "+56", countries: ["Chile"] },
  { code: "+57", countries: ["Colombia"] },
  { code: "+58", countries: ["Venezuela"] },
  { code: "+60", countries: ["Malaysia"] },
  { code: "+61", countries: ["Australia", "Christmas Island", "Cocos (Keeling) Islands"] },
  { code: "+62", countries: ["Indonesia"] },
  { code: "+63", countries: ["Philippines"] },
  { code: "+64", countries: ["New Zealand"] },
  { code: "+65", countries: ["Singapore"] },
  { code: "+66", countries: ["Thailand"] },
  { code: "+81", countries: ["Japan"] },
  { code: "+82", countries: ["South Korea"] },
  { code: "+84", countries: ["Vietnam"] },
  { code: "+86", countries: ["China"] },
  { code: "+90", countries: ["Türkiye"] },
  { code: "+91", countries: ["India"] },
  { code: "+92", countries: ["Pakistan"] },
  { code: "+93", countries: ["Afghanistan"] },
  { code: "+94", countries: ["Sri Lanka"] },
  { code: "+95", countries: ["Myanmar"] },
  { code: "+98", countries: ["Iran"] },
  { code: "+211", countries: ["South Sudan"] },
  { code: "+212", countries: ["Morocco", "Western Sahara"] },
  { code: "+213", countries: ["Algeria"] },
  { code: "+216", countries: ["Tunisia"] },
  { code: "+218", countries: ["Libya"] },
  { code: "+220", countries: ["Gambia"] },
  { code: "+221", countries: ["Senegal"] },
  { code: "+222", countries: ["Mauritania"] },
  { code: "+223", countries: ["Mali"] },
  { code: "+224", countries: ["Guinea"] },
  { code: "+225", countries: ["Côte d'Ivoire"] },
  { code: "+226", countries: ["Burkina Faso"] },
  { code: "+227", countries: ["Niger"] },
  { code: "+228", countries: ["Togo"] },
  { code: "+229", countries: ["Benin"] },
  { code: "+230", countries: ["Mauritius"] },
  { code: "+231", countries: ["Liberia"] },
  { code: "+232", countries: ["Sierra Leone"] },
  { code: "+233", countries: ["Ghana"] },
  { code: "+234", countries: ["Nigeria"] },
  { code: "+235", countries: ["Chad"] },
  { code: "+236", countries: ["Central African Republic"] },
  { code: "+237", countries: ["Cameroon"] },
  { code: "+238", countries: ["Cabo Verde"] },
  { code: "+239", countries: ["Sao Tome and Principe"] },
  { code: "+240", countries: ["Equatorial Guinea"] },
  { code: "+241", countries: ["Gabon"] },
  { code: "+242", countries: ["Congo"] },
  { code: "+243", countries: ["Congo, The Democratic Republic of the"] },
  { code: "+244", countries: ["Angola"] },
  { code: "+245", countries: ["Guinea-Bissau"] },
  { code: "+246", countries: ["British Indian Ocean Territory"] },
  { code: "+247", countries: ["AC"] },
  { code: "+248", countries: ["Seychelles"] },
  { code: "+249", countries: ["Sudan"] },
  { code: "+250", countries: ["Rwanda"] },
  { code: "+251", countries: ["Ethiopia"] },
  { code: "+252", countries: ["Somalia"] },
  { code: "+253", countries: ["Djibouti"] },
  { code: "+254", countries: ["Kenya"] },
  { code: "+255", countries: ["Tanzania"] },
  { code: "+256", countries: ["Uganda"] },
  { code: "+257", countries: ["Burundi"] },
  { code: "+258", countries: ["Mozambique"] },
  { code: "+260", countries: ["Zambia"] },
  { code: "+261", countries: ["Madagascar"] },
  { code: "+262", countries: ["Mayotte", "Réunion"] },
  { code: "+263", countries: ["Zimbabwe"] },
  { code: "+264", countries: ["Namibia"] },
  { code: "+265", countries: ["Malawi"] },
  { code: "+266", countries: ["Lesotho"] },
  { code: "+267", countries: ["Botswana"] },
  { code: "+268", countries: ["Eswatini"] },
  { code: "+269", countries: ["Comoros"] },
  { code: "+290", countries: ["Saint Helena, Ascension and Tristan da Cunha", "TA"] },
  { code: "+291", countries: ["Eritrea"] },
  { code: "+297", countries: ["Aruba"] },
  { code: "+298", countries: ["Faroe Islands"] },
  { code: "+299", countries: ["Greenland"] },
  { code: "+350", countries: ["Gibraltar"] },
  { code: "+351", countries: ["Portugal"] },
  { code: "+352", countries: ["Luxembourg"] },
  { code: "+353", countries: ["Ireland"] },
  { code: "+354", countries: ["Iceland"] },
  { code: "+355", countries: ["Albania"] },
  { code: "+356", countries: ["Malta"] },
  { code: "+357", countries: ["Cyprus"] },
  { code: "+358", countries: ["Finland", "Åland Islands"] },
  { code: "+359", countries: ["Bulgaria"] },
  { code: "+370", countries: ["Lithuania"] },
  { code: "+371", countries: ["Latvia"] },
  { code: "+372", countries: ["Estonia"] },
  { code: "+373", countries: ["Moldova"] },
  { code: "+374", countries: ["Armenia"] },
  { code: "+375", countries: ["Belarus"] },
  { code: "+376", countries: ["Andorra"] },
  { code: "+377", countries: ["Monaco"] },
  { code: "+378", countries: ["San Marino"] },
  { code: "+380", countries: ["Ukraine"] },
  { code: "+381", countries: ["Serbia"] },
  { code: "+382", countries: ["Montenegro"] },
  { code: "+383", countries: ["XK"] },
  { code: "+385", countries: ["Croatia"] },
  { code: "+386", countries: ["Slovenia"] },
  { code: "+387", countries: ["Bosnia and Herzegovina"] },
  { code: "+389", countries: ["North Macedonia"] },
  { code: "+420", countries: ["Czechia"] },
  { code: "+421", countries: ["Slovakia"] },
  { code: "+423", countries: ["Liechtenstein"] },
  { code: "+500", countries: ["Falkland Islands (Malvinas)"] },
  { code: "+501", countries: ["Belize"] },
  { code: "+502", countries: ["Guatemala"] },
  { code: "+503", countries: ["El Salvador"] },
  { code: "+504", countries: ["Honduras"] },
  { code: "+505", countries: ["Nicaragua"] },
  { code: "+506", countries: ["Costa Rica"] },
  { code: "+507", countries: ["Panama"] },
  { code: "+508", countries: ["Saint Pierre and Miquelon"] },
  { code: "+509", countries: ["Haiti"] },
  { code: "+590", countries: ["Guadeloupe", "Saint Barthélemy", "Saint Martin (French part)"] },
  { code: "+591", countries: ["Bolivia"] },
  { code: "+592", countries: ["Guyana"] },
  { code: "+593", countries: ["Ecuador"] },
  { code: "+594", countries: ["French Guiana"] },
  { code: "+595", countries: ["Paraguay"] },
  { code: "+596", countries: ["Martinique"] },
  { code: "+597", countries: ["Suriname"] },
  { code: "+598", countries: ["Uruguay"] },
  { code: "+599", countries: ["Bonaire, Sint Eustatius and Saba", "Curaçao"] },
  { code: "+670", countries: ["Timor-Leste"] },
  { code: "+672", countries: ["Norfolk Island"] },
  { code: "+673", countries: ["Brunei Darussalam"] },
  { code: "+674", countries: ["Nauru"] },
  { code: "+675", countries: ["Papua New Guinea"] },
  { code: "+676", countries: ["Tonga"] },
  { code: "+677", countries: ["Solomon Islands"] },
  { code: "+678", countries: ["Vanuatu"] },
  { code: "+679", countries: ["Fiji"] },
  { code: "+680", countries: ["Palau"] },
  { code: "+681", countries: ["Wallis and Futuna"] },
  { code: "+682", countries: ["Cook Islands"] },
  { code: "+683", countries: ["Niue"] },
  { code: "+685", countries: ["Samoa"] },
  { code: "+686", countries: ["Kiribati"] },
  { code: "+687", countries: ["New Caledonia"] },
  { code: "+688", countries: ["Tuvalu"] },
  { code: "+689", countries: ["French Polynesia"] },
  { code: "+690", countries: ["Tokelau"] },
  { code: "+691", countries: ["Micronesia, Federated States of"] },
  { code: "+692", countries: ["Marshall Islands"] },
  { code: "+850", countries: ["North Korea"] },
  { code: "+852", countries: ["Hong Kong"] },
  { code: "+853", countries: ["Macao"] },
  { code: "+855", countries: ["Cambodia"] },
  { code: "+856", countries: ["Laos"] },
  { code: "+880", countries: ["Bangladesh"] },
  { code: "+886", countries: ["Taiwan"] },
  { code: "+960", countries: ["Maldives"] },
  { code: "+961", countries: ["Lebanon"] },
  { code: "+962", countries: ["Jordan"] },
  { code: "+963", countries: ["Syria"] },
  { code: "+964", countries: ["Iraq"] },
  { code: "+965", countries: ["Kuwait"] },
  { code: "+966", countries: ["Saudi Arabia"] },
  { code: "+967", countries: ["Yemen"] },
  { code: "+968", countries: ["Oman"] },
  { code: "+970", countries: ["Palestine, State of"] },
  { code: "+971", countries: ["United Arab Emirates"] },
  { code: "+972", countries: ["Israel"] },
  { code: "+973", countries: ["Bahrain"] },
  { code: "+974", countries: ["Qatar"] },
  { code: "+975", countries: ["Bhutan"] },
  { code: "+976", countries: ["Mongolia"] },
  { code: "+977", countries: ["Nepal"] },
  { code: "+992", countries: ["Tajikistan"] },
  { code: "+993", countries: ["Turkmenistan"] },
  { code: "+994", countries: ["Azerbaijan"] },
  { code: "+995", countries: ["Georgia"] },
  { code: "+996", countries: ["Kyrgyzstan"] },
  { code: "+998", countries: ["Uzbekistan"] },
];

/** Dial codes are displayed as the code alone (e.g. "+972"); `countries` is kept for reference. */
export const countriesFor = (code) => (PHONE_CODES.find((c) => c.code === code) || {}).countries || [];
